import styled from 'styled-components';
import Progress, { ProgressShape } from '../Progress/Progress';

interface LoadingProps {
    shape?: ProgressShape;
    children?: any;
}

export default function Loading({ children, shape = ProgressShape.CIRCULAR }: LoadingProps) {

    if (children) return null;
    return (
        <Progress shape={shape} value='indeterminate'></Progress>
    )
}

const Wrapper = styled.div`
    
`